import { GameDef } from './types';
import { STAR_POP } from './StarPop';
import { WHACK_A_MOLE } from './WhackAMole';
import { MEMORY_MATCH } from './MemoryMatch';
import { CATCH_FALLING } from './CatchFalling';
import { BUBBLE_POP } from './BubblePop';

export type { GameDef, GameProps, GameResult, GameTheme } from './types';

// Registry of all streak-reward mini-games. StreakReward rotates through these
// so each break feels fresh. Order here is the rotation order.
export const GAMES: GameDef[] = [
  STAR_POP,
  WHACK_A_MOLE,
  MEMORY_MATCH,
  CATCH_FALLING,
  BUBBLE_POP,
];

export function gameById(id: string): GameDef | undefined {
  return GAMES.find(g => g.id === id);
}

// Pick a game by a rotating index (e.g. how many rewards earned so far).
export function gameByRotation(n: number): GameDef {
  return GAMES[((n % GAMES.length) + GAMES.length) % GAMES.length];
}
